<template>
  <PurchaserListDialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="visible"
    :popup-width="'900px'"
    :showCloseBtn="showCloseBtn"
    :showBtn="showBtn"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
  >
    <e-search
            :data="filterInfo.data"
            :field-list="filterInfo.fieldList"
            @handleFilter="handleSearch"
            @handleReset="handleReset"
            class="margin-b20"
    ></e-search>
    <TableList
            maxHeight="240"
      :table-data="tableData"
      :table-label="tableLabel"
      :loading="loading"
      :selection-show="multipleSelection"
      :index-show="indexShow"
    >
      <template #companyName="slot">
        <div style="font-size: 12px; text-align: left">
          {{ slot.scope.row.companyName }}
        </div>
      </template>
    </TableList>

    <div class="pagination">
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        :page-sizes="[10, 20,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="productTagPage.currentPage"
        :page-size="productTagPage.pageSize"
        :total="productTagPage.pageTotal"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </PurchaserListDialog>
</template>

<script>
import EuiBtn from 'epec-ui/src/package/eui-btn/index';
import PurchaserListDialog from '../../../../../components/common/epecDialog';
import TableList from '../../common/e-table-list';
import eSearch from '../../common/e-search';
import agreementApi from '../../../api/agreement/index';

export default {
  name: 'PachurserListDialog',
  components: {
    EuiBtn,
    PurchaserListDialog,
    TableList,
    eSearch
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    agreementId: {
      type: Number,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      showCloseBtn:true,
      showBtn:false,
      filterInfo: {
        data: {
          companyId:null,
          companyName:null,
        },
        fieldList: [
          { label: '公司ID',type: 'inputnumber', value: 'companyId',},
          { label: '采购商名称',type: 'input', value: 'companyName',},
        ],
      },
      loading: false,
      tableData: [],
      tableLabel: [
        { label: '公司ID', param: 'companyId', align: 'center',width:'200' ,},
        { label: '采购商名称', param: 'companyName', align: 'center',},
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      query: {
        companyName: '',
      },
      multipleSelection: false,
      indexShow: true,
    };
  },
  computed: {},
  created() {
    this.getPachurserList();
  },
  methods: {
    handleReset(){
      this.query = {
        companyName:null,
        companyId:null,
      }
      this.productTagPage.currentPage = 1
      this.getPachurserList()
    },
    handleSearch(val){
      console.log(val,'val')
      this.query.companyId = val.companyId;
      this.query.companyName = val.companyName;
      this.productTagPage.currentPage = 1
      this.getPachurserList()
    },
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      this.getPachurserList();
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.getPachurserList();
    },
    updateVisible() {},
    resetPopupData() {
      this.$emit('close');
    },
    submitPopupData() {
      this.$emit('close');
    },
    getPachurserList() {
      const params = this.formatParams();
      agreementApi.getMemberList(params).then((res) => {
        if (res.data) {
          this.tableData = res.data.records;
          this.productTagPage.pageTotal = res.data.total;
        }
      });
    },
    formatParams() {
      const res = {};
      res.agreementId = this.agreementId;
      res.pageNum = this.productTagPage.currentPage;
      res.pageSize = this.productTagPage.pageSize;
      res.companyName = this.query.companyName;
      res.companyId = this.query.companyId
      return res;
    },
  },
};
</script>

<style scoped></style>
